/*
 * ProjectList.tsx
 * This Project list Component is used for representing the list of project categories, task categories and status.
 */
import { useContext, useEffect, useState } from "react";
import { eConfigurations } from "../../../utils/enum";
import ProjectCategoryList from "./project-categories/project-category-list";
import { UserContext } from "../../../context";
import Utils from "../../../utils";
import styles from "./project.module.css";
import TaskCategoryList from "./work-categories/work-category-list";
import StatusList from "./statuses/status-list";

function ConfigurationsWrapper() {
  const context: any = useContext(UserContext);
  const [activeProject, setActiveProject] = useState<string>(
    eConfigurations.PROJECTCATEGORY
  );

  return (
    <div>
      <div className={styles.parentContainer}>
        <div
          className={`${styles.tab} ${
            activeProject === eConfigurations.PROJECTCATEGORY
              ? styles.activeTab
              : ""
          }`}
          onClick={() => {
            setActiveProject(eConfigurations.PROJECTCATEGORY);
          }}
        >
          <span
            className={
              activeProject === eConfigurations.PROJECTCATEGORY
                ? styles.activeText
                : styles.inactiveText
            }
          >
            Project Categories
          </span>
        </div>
        {/* )} */}
        {/* Check if user has permission to view already created schedules list */}
        {/* {Utils.isUserHasAccess(
          context.user?.privilegeList,
          ePrivileges.VIEWTASKCATEGORY
        ) && ( */}
        <div
          className={`${styles.tab} ${
            activeProject === eConfigurations.WORKCATEGORY
              ? styles.activeTab
              : ""
          }`}
          onClick={() => {
            setActiveProject(eConfigurations.WORKCATEGORY);
          }}
        >
          <span
            className={
              activeProject === eConfigurations.WORKCATEGORY
                ? styles.activeText
                : styles.inactiveText
            }
          >
            Work Categories
          </span>
        </div>
        {/* )} */}

        {/* {Utils.isUserHasAccess(
          context.user?.privilegeList,
          ePrivileges.DOWNLOADAMCSUMMARYREPORT
        ) && ( */}
        <div
          className={`${styles.tab} ${
            activeProject === eConfigurations.STATUS ? styles.activeTab : ""
          }`}
          onClick={() => {
            setActiveProject(eConfigurations.STATUS);
          }}
        >
          <span
            className={
              activeProject === eConfigurations.STATUS
                ? styles.activeText
                : styles.inactiveText
            }
          >
            Status
          </span>
        </div>
        {/* )} */}
      </div>
      <div>
        {{
          [eConfigurations.PROJECTCATEGORY]: <ProjectCategoryList />,
          [eConfigurations.WORKCATEGORY]: <TaskCategoryList />,
          [eConfigurations.STATUS]: <StatusList />,
        }[activeProject] || null}
      </div>
    </div>
  );
}

export default ConfigurationsWrapper;
